
//GENERAL API FETCH ERROR
export const FETCH_DATA_ERROR = 'Something went wrong fetching data.';

export const STATUS_IN_PROGRESS = "In progress";
export const STATUS_SUCCESSFUL = "Successfully done";
export const STATUS_FAILED = "Failed" ; 